<script>import { formFieldProxy } from "sveltekit-superforms/client";
import { writable } from "svelte/store";
import { createFormField, createIds } from "../internal/index.js";
export let config;
export let name;
const attrStore = writable({});
$:
  ({ errors, value, constraints } = formFieldProxy(config.form, name));
const ids = writable(createIds());
$:
  ({ getFieldAttrs, actions, hasValidation, hasDescription, handlers, setValue } = createFormField(name, attrStore, value, errors, ids));
$:
  inputAttrs = getFieldAttrs({
    val: $value,
    errors: $errors,
    constraints: $constraints,
    hasValidation: $hasValidation,
    hasDescription: $hasDescription
  });
$:
  attrs = {
    input: inputAttrs,
    label: {
      for: $ids.input
    },
    description: {
      id: $ids.description
    },
    validation: {
      id: $ids.validation,
      "aria-live": "assertive"
    }
  };
const stores = {
  errors,
  value,
  constraints
};
</script>

<slot
	{stores}
	errors={$errors}
	value={$value}
	constraints={$constraints}
	{handlers}
	{attrs}
	{actions}
	{setValue}
/>
